import {TFunction} from 'i18next';
import {createContext} from 'react';
import {IContentTabV4, IViewData} from './type';
import {HEADER_HEIGHT_V4} from '../common/scss/util/variable';
import {IBadge} from '../common/type';
import {
  ISendEventParam,
  ISendViewImpParam,
  sendEvent,
  sendViewImp,
} from '../common/util/tracking';
import {IEpisodeType} from '../commonSub/type';

export const CONTENT_TAB_HEIGHT = 64;

export const BG_CONTENT_CN = 'bg-content-home';

export const ContentPageContext = createContext<{
  isStopContent: boolean;
}>({
  isStopContent: false,
});

export function sendPurchaseEvent(
  params: Pick<
    ISendEventParam,
    'actionName' | 'action' | 'customProps' | 'ecommerceContents' | 'kind'
  >
) {
  sendEvent({
    section: 'ticketpurchase',
    page: 'ticketpurchase',
    ...params,
  });
}

export function sendPurchaseViewImp(
  params: Pick<ISendViewImpParam, 'customProps' | 'viewImpContents'>
) {
  sendViewImp({
    section: 'ticketpurchase',
    page: 'ticketpurchase',
    ...params,
  });
}

export const TRACKING_PAGE_NAME: {[key in IContentTabV4]: string} = {
  first: 'content_preview_first',
  continue: 'content_preview_continue',
  episode: 'content_episode',
  profile: 'content_info',
  ticket: 'content_ticket',
  comments: 'content_comments',
};
export const TRACKING_TAB_NAME: {[key in IContentTabV4]: string} = {
  first: 'first_tab',
  continue: 'continue_tab',
  episode: 'episode_tab',
  profile: 'info_tab',
  ticket: 'ticket_tab',
  comments: 'comments_tab',
};

export const TAB_HEIGHT = 36;
export const TAB_PADDING_TOP = 10;
export const TAB_PADDING_BOTTOM = 4;
export const FIXED_TAB_PADDING_TOP = HEADER_HEIGHT_V4 - TAB_PADDING_TOP;

export const TAB_CONTENT_CONTAINER_CN = 'tab-content-container';

export const USE_TYPE_TEXT_MAP: {[key in IEpisodeType]?: string} = {
  free: 'common_free',
  pay: 'common_paid',
  earlyAccess: 'common_bm_preview',
  waitForFree: 'common_gidamu',
  waitForFreeWaiting: 'common_gidamu',
  rental: 'common_rental',
  possession: 'common_purchased',
};

export const CONTENT_TICKET_HISTORY_ITEM_CN =
  'border-b border-solid border-grey-03 py-20 last:border-none';

export const NEAR_TOP_OFFSET = 50;

// 한국에서만 사용하므로 번역키를 사용하지 않는다.
export const WEBTOON_RELATED_NOVEL_LABEL = '이 웹툰의 관련 소설';

export function getWaitfreeIntervalBadge({
  badges,
  intervalMinutes,
  t,
}: {
  badges: IBadge[];
  intervalMinutes?: number;
  t: TFunction;
}): IBadge[] {
  if (!intervalMinutes) return badges;

  const waitfreeHour = Math.floor(intervalMinutes / 60);
  const waitfreeDay = Math.floor(waitfreeHour / 24);

  return [
    ...badges,
    {
      label:
        waitfreeDay >= 1
          ? t('contenthome_ticketbar_gidamu', {
              count: waitfreeDay,
            })
          : waitfreeHour >= 1
            ? t('contenthome_ticketbar_gidamu_hour', {count: waitfreeHour})
            : t('contenthome_ticketbar_gidamu_minute', {
                count: intervalMinutes,
              }),
      variant: 's10_white_black_03',
    },
  ];
}

export function getCanViewFirstEpisode(viewData: IViewData) {
  const {content, episode} = viewData;
  return !(
    content.isPageViewDefault ||
    episode.isStopSalesEpisode ||
    (episode.type !== 'free' && !episode.readable)
  );
}
